import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { baseUrl: String }
  static targets = ["question", "result", "progress", "dot"]

  connect() {
    this.answers = [null, null, null]
    this.currentQuestion = 0
  }

  get redirectTable() {
    return {
      aaa: "romance", aab: "romance", aac: "romance",
      aba: "romance", abb: "eclectique", abc: "eclectique",
      aca: "romance", acb: "eclectique", acc: "dystopie",
      baa: "romance", bab: "thriller", bac: "eclectique",
      bba: "thriller", bbb: "thriller", bbc: "thriller",
      bca: "eclectique", bcb: "thriller", bcc: "dystopie",
      caa: "romance", cab: "eclectique", cac: "dystopie",
      cba: "eclectique", cbb: "thriller", cbc: "dystopie",
      cca: "dystopie", ccb: "dystopie", ccc: "dystopie"
    }
  }

  selectAnswer(event) {
    const questionIndex = parseInt(event.currentTarget.dataset.question)
    const answer = event.currentTarget.dataset.answer
    this.answers[questionIndex] = answer

    const options = event.currentTarget.parentElement.querySelectorAll("[data-action*='selectAnswer']")
    options.forEach(opt => opt.classList.remove("selected"))
    event.currentTarget.classList.add("selected")

    setTimeout(() => {
      if (questionIndex < 2) {
        this.showQuestion(questionIndex + 1)
      } else {
        const key = this.answers.join("")
        const result = this.redirectTable[key]
        if (result === "eclectique") {
          this.showQuestion(3)
        } else {
          this.showResult(result)
        }
      }
    }, 300)
  }

  selectTiebreaker(event) {
    const genre = event.currentTarget.dataset.genre
    const options = event.currentTarget.parentElement.querySelectorAll("[data-action*='selectTiebreaker']")
    options.forEach(opt => opt.classList.remove("selected"))
    event.currentTarget.classList.add("selected")
    setTimeout(() => this.showResult(genre), 300)
  }

  goBack(event) {
    const toIndex = parseInt(event.currentTarget.dataset.backTo)
    this.answers[toIndex] = null
    const question = this.questionTargets[toIndex]
    question.querySelectorAll(".quiz-option").forEach(opt => opt.classList.remove("selected"))
    this.showQuestion(toIndex)
  }

  restart() {
    this.answers = [null, null, null]
    this.currentQuestion = 0
    this.resultTargets.forEach(r => r.classList.remove("active"))
    this.questionTargets.forEach(q => q.querySelectorAll(".quiz-option").forEach(o => o.classList.remove("selected")))
    this.progressTarget.style.display = "flex"
    this.showQuestion(0)
    this.element.scrollIntoView({ behavior: "smooth" })
  }

  showQuestion(index) {
    this.questionTargets.forEach(q => q.classList.remove("active"))
    this.questionTargets[index].classList.add("active")
    this.updateDots(index)
    this.currentQuestion = index
  }

  updateDots(activeIndex) {
    this.dotTargets.forEach((dot, i) => {
      dot.classList.remove("active", "done")
      if (i < activeIndex) dot.classList.add("done")
      else if (i === activeIndex) dot.classList.add("active")
    })
  }

  showResult(genre) {
    this.questionTargets.forEach(q => q.classList.remove("active"))
    this.progressTarget.style.display = "none"
    const resultEl = this.resultTargets.find(r => r.dataset.genre === genre)
    resultEl.classList.add("active")
    const link = resultEl.querySelector("a[data-cta]")
    if (link) { link.href = `${this.baseUrlValue}/${genre}` }
    resultEl.scrollIntoView({ behavior: "smooth", block: "center" })
  }
}
